import { useState, useEffect } from "react";
import {
  fetchTestimonials,
  defaultTestimonials,
  type Testimonial,
} from "@/lib/testimonialsService";

export interface UseTestimonialsReturn {
  testimonials: Testimonial[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

/**
 * Custom hook for managing testimonials data
 */
export const useTestimonials = (): UseTestimonialsReturn => {
  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadTestimonials = async () => {
    try {
      setLoading(true);
      setError(null);

      const fetchedTestimonials = await fetchTestimonials();

      if (fetchedTestimonials.length > 0) {
        setTestimonials(fetchedTestimonials);
      } else {
        setTestimonials(defaultTestimonials);
      }
    } catch (err) {
      console.error("Error loading testimonials:", err);
      setError("Failed to load testimonials");
      setTestimonials(defaultTestimonials);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTestimonials();
  }, []);

  return {
    testimonials,
    loading,
    error,
    refetch: loadTestimonials,
  };
};
